import axios from './axios'

export {
	axios,
}


// WEBPACK FOOTER //
// ./src/utils/index.js